import React from 'react';
import { HeroSection } from './components/resume/HeroSection';
import { AboutSection } from './components/resume/AboutSection';
import { CompetenciesGrid } from './components/resume/CompetenciesGrid';
import { ExperienceTimeline } from './components/resume/ExperienceTimeline';
import { LeadershipImpact } from './components/resume/LeadershipImpact';
import { EducationSection } from './components/resume/EducationSection';
import { ContactSection } from './components/resume/ContactSection';
const navLinks = [{
  href: '#hero',
  label: 'Profile'
}, {
  href: '#about',
  label: 'About'
}, {
  href: '#competencies',
  label: 'Expertise'
}, {
  href: '#experience',
  label: 'Experience'
}, {
  href: '#impact',
  label: 'Impact'
}, {
  href: '#contact',
  label: 'Contact'
}];
export function App() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)',
    color: 'var(--text-primary)'
  }} data-id="element-0">
      {/* Sticky nav */}
      <nav className="fixed top-0 inset-x-0 z-50 flex items-center justify-between px-6 py-4" style={{
      backgroundColor: 'rgba(10,10,10,0.92)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(201,150,62,0.12)'
    }} data-id="element-1">
        <a href="#hero" className="flex items-center justify-center w-9 h-9 rounded-sm font-bold text-sm transition-all duration-200" style={{
        fontFamily: 'Playfair Display, serif',
        background: 'linear-gradient(135deg, var(--gold-dark), var(--gold))',
        color: '#0a0a0a',
        textDecoration: 'none',
        letterSpacing: '0.05em'
      }} data-id="element-2">
          RM
        </a>

        <div className="hidden md:flex items-center gap-6" data-id="element-3">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-xs font-medium tracking-widest uppercase transition-colors duration-200" style={{
          fontFamily: 'Inter, sans-serif',
          color: 'var(--text-muted)',
          textDecoration: 'none',
          letterSpacing: '0.12em'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.color = 'var(--gold)';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.color = 'var(--text-muted)';
        }} data-id="element-4">
              {link.label}
            </a>)}
        </div>

        <a href="#contact" className="hidden sm:flex items-center gap-1.5 px-4 py-2 rounded-sm text-xs font-semibold tracking-widest uppercase transition-all duration-200" style={{
        fontFamily: 'Inter, sans-serif',
        backgroundColor: 'transparent',
        border: '1px solid rgba(201,150,62,0.4)',
        color: 'var(--gold)',
        textDecoration: 'none',
        letterSpacing: '0.1em'
      }} onMouseEnter={e => {
        const el = e.currentTarget as HTMLAnchorElement;
        el.style.backgroundColor = 'rgba(201,150,62,0.1)';
        el.style.borderColor = 'var(--gold)';
      }} onMouseLeave={e => {
        const el = e.currentTarget as HTMLAnchorElement;
        el.style.backgroundColor = 'transparent';
        el.style.borderColor = 'rgba(201,150,62,0.4)';
      }} data-id="element-5">
          Contact
        </a>
      </nav>

      <main data-id="element-6">
        <HeroSection data-id="element-7" />

        <div className="max-w-5xl mx-auto px-6" data-id="element-8">
          <div className="section-divider" data-id="element-9" />
        </div>
        <AboutSection data-id="element-10" />

        <div className="max-w-5xl mx-auto px-6" data-id="element-11">
          <div className="section-divider" data-id="element-12" />
        </div>
        <CompetenciesGrid data-id="element-13" />

        <div className="max-w-5xl mx-auto px-6" data-id="element-14">
          <div className="section-divider" data-id="element-15" />
        </div>
        <ExperienceTimeline data-id="element-16" />

        <div className="max-w-5xl mx-auto px-6" data-id="element-17">
          <div className="section-divider" data-id="element-18" />
        </div>
        <EducationSection data-id="element-19" />

        <div className="max-w-5xl mx-auto px-6" data-id="element-20">
          <div className="section-divider" data-id="element-21" />
        </div>
        <LeadershipImpact data-id="element-22" />

        <ContactSection data-id="element-23" />
      </main>
    </div>;
}